<template>
  <div>
    <v-container class="mt-4">
      <v-row>
        <v-col>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="">Company Name</span>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="getUserCompany.name"
              @blur="updateCompanyInfo($event, 'name', 'companies')"
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup"
            >Primary Address</label
          >
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Primary Address</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Primary Address"
              v-model="getUserCompany.primary_address"
              @blur="updateCompanyInfo($event, 'primary_address', 'companies')"
            />
          </div>
        </v-col>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup"
            >Primary Contact</label
          >
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Primary Contact</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Primary Contact"
              v-model="getUserCompany.primary_phone"
              @blur="updateCompanyInfo($event, 'primary_phone', 'companies')"
            />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="inputGroupSelect01"
                >Select Currency</label
              >
            </div>
            <v-autocomplete
              v-model="selectedCurrency"
              :items="currencies"
              flat
              hide-no-data
              hide-details
              label="Currencies"
              solo
              @change="getSelectedCurrency"
            ></v-autocomplete>
          </div>
        </v-col>

        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup"
            >Account Number</label
          >
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Account Number</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Account Number"
              v-model="getUserCompany.account_number"
              @blur="updateCompanyInfo($event, 'account_number', 'companies')"
            />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup">Bank Name</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Bank Name</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Bank Name"
              v-model="getUserCompany.bank"
              @blur="updateCompanyInfo($event, 'bank', 'companies')"
            />
          </div>
        </v-col>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup">Account Type</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Account Type</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Account Type"
              v-model="getUserCompany.account_type"
              @blur="updateCompanyInfo($event, 'account_type', 'companies')"
            />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="isMobile ? 12 : 4">
          <label class="sr-only" for="inlineFormInputGroup">Email</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Email</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Email"
              v-model="getUserCompany.email"
              @blur="updateCompanyInfo($event, 'email', 'companies')"
            />
          </div>
        </v-col>
        <v-col :cols="isMobile ? 6 : 4">
          <label class="sr-only" for="inlineFormInputGroup">City</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">City</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="City"
              v-model="getUserCompany.city"
              @blur="updateCompanyInfo($event, 'city', 'companies')"
            />
          </div>
        </v-col>

        <v-col :cols="isMobile ? 6 : 4">
          <label class="sr-only" for="inlineFormInputGroup">Post Code</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Post Code</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Post Code"
              v-model="getUserCompany.postal_code"
              @blur="updateCompanyInfo($event, 'postal_code', 'companies')"
            />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup">Merchant Key</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Merchant Key</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Merchant Key"
              :disabled="
                getCurrentUser && getCurrentUser.email == 'adubyte2@yahoo.com'
                  ? false
                  : true
              "
              v-model="getUserCompany.merchant_key"
              @blur="updateCompanyInfo($event, 'merchant_key', 'companies')"
            />
          </div>
        </v-col>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup"
            >Merchant Number</label
          >
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Merchant Number</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Merchant Number"
              :disabled="
                getCurrentUser && getCurrentUser.email == 'adubyte2@yahoo.com'
                  ? false
                  : true
              "
              v-model="getUserCompany.merchant_number"
              @blur="updateCompanyInfo($event, 'merchant_number', 'companies')"
            />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="">Motto</span>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="getUserCompany.motto"
              @blur="updateCompanyInfo($event, 'motto', 'company_profile')"
            />
          </div>
        </v-col>
      </v-row>

      <!-- <v-row>
        <v-col>
          <div class="card text-center">
            <div class="card-header">Featured</div>
            <div class="card-body">
              <h5 class="card-title">Special title treatment</h5>
              <p class="card-text">
                With supporting text below as a natural lead-in to additional
                content.
              </p>
              <a href="#" class="btn btn-primary">Go somewhere</a>
            </div>
            <div class="card-footer text-muted">2 days ago</div>
          </div>
        </v-col>
      </v-row> -->

      <!-- <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup">Username</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">@</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Username"
            />
          </div>
        </v-col>
        <v-col :cols="isMobile ? 12 : 6">
          <label class="sr-only" for="inlineFormInputGroup">Username</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">@</div>
            </div>
            <input
              type="text"
              class="form-control"
              id="inlineFormInputGroup"
              placeholder="Username"
            />
          </div>
        </v-col>
      </v-row> -->

      <!-- <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="customRadio1"
              name="customRadio"
              class="custom-control-input"
            />
            <label class="custom-control-label" for="customRadio1"
              >Toggle this custom radio</label
            >
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="customRadio2"
              name="customRadio"
              class="custom-control-input"
            />
            <label class="custom-control-label" for="customRadio2"
              >Or toggle this other custom radio</label
            >
          </div>
        </v-col>
        <v-col :cols="isMobile ? 12 : 6">
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="validatedCustomFile"
              required
            />
            <label class="custom-file-label" for="validatedCustomFile"
              >Choose file...</label
            >
            <div class="invalid-feedback">Feedback</div>
          </div>
        </v-col>
      </v-row> -->

      <v-row>
        <v-col cols="12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">Mission</span>
            </div>
            <textarea
              class="form-control"
              aria-label="Mission"
              rows="5"
              v-model="getUserCompany.mission"
              @blur="updateCompanyInfo($event, 'mission', 'company_profile')"
            ></textarea>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">Vision</span>
            </div>
            <textarea
              class="form-control"
              aria-label="Vision"
              rows="5"
              v-model="getUserCompany.vision"
              @blur="updateCompanyInfo($event, 'vission', 'company_profile')"
            ></textarea>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">About Us</span>
            </div>
            <textarea
              class="form-control"
              aria-label="About Us"
              rows="5"
              v-model="getUserCompany.about_us"
              @blur="updateCompanyInfo($event, 'about_us', 'company_profile')"
            ></textarea>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- <div class="container">
      <form id="editor-form" class="form form-horizontal">
        <div class="form-group">
          <label for="name" class="col-sm-2 control-label">Name</label>
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control"
              aria-label="Name"
              name="name"
              id="name"
            />
          </div>
          <label for="timer" class="col-sm-2 control-label"
            >Update Interval</label
          >
          <div class="col-sm-2">
            <input
              type="number"
              min="0"
              class="form-control"
              aria-label="Timer"
              placeholder="0"
              name="timer"
              id="timer"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="w" class="col-sm-2 control-label">Width</label>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon"> Min </span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Minimum Width"
                name="minw"
                placeholder="1"
                id="minw"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon"> Default </span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Default Width"
                name="w"
                placeholder="3"
                id="w"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon"> Max </span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Maximum Width"
                name="maxw"
                placeholder="8"
                id="maxw"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="h" class="col-sm-2 control-label">Height</label>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon"> Min </span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Minimum Height"
                name="minh"
                placeholder="1"
                id="minh"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon"> Default </span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Default Height"
                name="h"
                placeholder="3"
                id="h"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon"> Max </span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Maximum Height"
                name="maxh"
                placeholder="8"
                id="maxh"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="x" class="col-sm-2 control-label">Position</label>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon">X</span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Initial X Position"
                name="x"
                placeholder="1"
                id="x"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="input-group">
              <span class="input-group-addon">Y</span>
              <input
                type="number"
                min="0"
                max="15"
                class="form-control"
                aria-label="Initial Y Position"
                name="y"
                placeholder="0"
                id="y"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="type" class="col-sm-2 control-label">Type</label>
          <div class="col-sm-4">
            <label class="radio-inline">
              <input
                type="radio"
                name="type"
                id="typefunction"
                value="function"
                checked="checked"
              />
              Function
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                name="type"
                id="typerss"
                value="rss"
                checked="checked"
              />
              RSS URL
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                name="type"
                id="typequery"
                value="query"
                checked="checked"
              />
              Query
            </label>
          </div>
        </div>
        <div class="form-group type type-function active">
          <label for="function" class="col-sm-2 control-label">Function</label>
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control"
              aria-label="Function"
              name="function"
              id="function"
            />
          </div>
        </div>
        <div class="form-group type type-rss active">
          <label for="rss" class="col-sm-2 control-label">URL</label>
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control"
              aria-label="URL"
              name="rss"
              id="rss"
            />
          </div>
        </div>
        <div class="form-group type type-query active">
          <label for="query" class="col-sm-2 control-label">Query</label>
          <div class="col-sm-10">
            <textarea class="form-control" rows="3" name="query" id="query">
TextArea</textarea
            >
          </div>
        </div>
        <div class="form-group type type-query active">
          <label for="module" class="col-sm-2 control-label">Module</label>
          <div class="col-sm-2">
            <select id="module" class="form-control" name="module">
              <option value="">Select Module</option>
              <option value="default" selected>Default</option>
              <option value="all" selected>All</option>

              <option value="" selected>settings</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for="overflow" class="col-sm-2 control-label"
            >Overflow Handling</label
          >
          <div class="col-sm-10">
            <label class="radio-inline">
              <input
                type="radio"
                name="overflow"
                id="overflow"
                value="none"
                checked="checked"
              />
              None
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                name="overflow"
                value="cut"
                checked="checked"
              />
              Cut-Off
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                name="overflow"
                value="pager"
                checked="checked"
              />
              Pager
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                name="overflow"
                value="scroll"
                checked="checked"
              />
              Scroll
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                name="overflow"
                value="shrink"
                checked="checked"
              />
              Shrink
            </label>
          </div>
        </div>
        <div class="form-group">
          <label for="html" class="col-sm-2 control-label">HTML Template</label>
          <div class="col-sm-10">
            <textarea class="form-control" rows="3" name="html" id="html">
widget.html</textarea
            >
          </div>
        </div>
        <div class="form-group">
          <label for="row_html" class="col-sm-2 control-label"
            >Per-Row HTML</label
          >
          <div class="col-sm-10">
            <textarea
              class="form-control"
              rows="3"
              name="row_html"
              id="row_html"
            >
$widget.row_html</textarea
            >
          </div>
        </div>
        <div class="form-group">
          <label for="row_html" class="col-sm-2 control-label"
            >Per-Row JS</label
          >
          <div class="col-sm-10">
            <textarea class="form-control" rows="3" name="row_js" id="row_js">
widget.row_js</textarea
            >
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-4">
            <label for="js-libs">JS Libraries</label>
            <span id="js-libs-add" class="pull-right btn btn-xs btn-primary"
              ><i class="fa fa-plus"></i> Add</span
            >
            <div class="widget-content">
              <div id="js-libs" class="list-group">
                <input
                  type="text"
                  name="js-libs[]"
                  class="list-group-item"
                  style="width: 100%"
                  value="{$file}}"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-offset-2 col-sm-10">
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </div>
      </form>
    </div> -->
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";

export default {
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  mounted() {
    this.getAllCurrenciesAsArray();
  },
  data: () => ({
    currencies: [],
    selectedCurrency: null,
  }),
  methods: {
    getAllCurrenciesAsArray() {
      const currencies = helpersJs.getAllCurrenciesAsArray();
      if (currencies.length > 0) {
        currencies.forEach((currency) => {
          this.currencies.push({
            text: `${currency.name} [${currency.symbol}]`,
            value: currency.symbol,
          });
        });
      }
      this.selectedCurrency = this.getUserCompany.currency;
    },
    async updateCompanyInfo(event, column, table) {
      const value = event.target.value;
      let rowID = null;
      if (table == "company_profile") {
        rowID = this.getUserCompany.company_profile.id;
      } else if (table == "site_colors") {
        rowID = this.getUserCompany.site_colors.id;
      } else {
        rowID = this.getUserCompany.company.id;
      }
      this.$store.commit("setUserCompany", this.getUserCompany);
      const company = await helpersJs.updateModelSingleRow(
        table,
        column,
        rowID,
        value
      );
      if (company && company.emis) {
        this.$store.commit("setUserCompany", company);
      }
      this.$toast.success("Company Profile Updated Successfully!", {
        duration: 3000,
      });
    },
    async getSelectedCurrency() {
      const company = await helpersJs.updateModelSingleRow(
        "companies",
        "currency",
        this.getUserCompany.company.id,
        this.selectedCurrency
      );
      this.$store.commit("setUserCompany", company);
      this.$toast.success("Currency Updated Successfully!", { duration: 3000 });
    },
  },
};
</script>

<style lang="scss" scoped>
#editor-form .type {
  display: none;
}
#editor-form .type.active {
  display: block;
}
#editor-form textarea {
  white-space: nowrap;
  overflow-x: scroll;
}
</style>
